module.exports = __webpack_public_path__ + "static/media/performance.bc5a3752.png";